import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail, MapPin, Phone } from "lucide-react";
import { Crescent } from "./Decor";
import { DonateButton } from "./DonateButton";
import { EVENT } from "../lib/data";

export const Footer = () => (
  <footer className="bg-forest text-cream border-t-4 border-gold" data-testid="footer">
    <div className="max-w-7xl mx-auto px-6 md:px-8 py-14 grid md:grid-cols-3 gap-10">
      <div>
        <div className="flex items-center gap-3 mb-4">
          <Crescent size={44} />
          <span className="numeral text-3xl tracking-wide">PAK FEST 2026</span>
        </div>
        <p className="tagline-italic text-gold-light text-xl mb-3">{EVENT.tagline}</p>
        <p className="font-mono text-xs text-cream/70 leading-relaxed">
          Hosted by the Canada Pakistan Trade and Culture Association (CPTCA). A free, family-friendly
          celebration of Pakistani culture, food and community.
        </p>
        <div className="mt-5">
          <DonateButton className="btn-rust px-6 py-3 text-xs" label="Support / Donate" testid="footer-donate" />
        </div>
      </div>

      <div>
        <h4 className="eyebrow text-gold mb-4">The Details</h4>
        <ul className="space-y-2 font-mono text-sm text-cream/85">
          <li>{EVENT.dateLabel}</li>
          <li>{EVENT.timeLabel}</li>
          <li className="flex items-start gap-2"><MapPin size={16} className="mt-0.5 text-gold" />{EVENT.venue}, {EVENT.address}</li>
        </ul>
      </div>

      <div>
        <h4 className="eyebrow text-gold mb-4">Connect</h4>
        <ul className="space-y-2 font-mono text-sm text-cream/85 mb-5">
          <li className="flex items-center gap-2"><Phone size={16} className="text-gold" /><a href="tel:+12049518164" className="hover:text-gold transition-colors" data-testid="footer-phone">204-951-8164</a></li>
          <li className="flex items-center gap-2"><Mail size={16} className="text-gold" /><a href="mailto:cptcamb@gmail.com" className="hover:text-gold transition-colors">cptcamb@gmail.com</a></li>
        </ul>
        <div className="flex items-center gap-4 mb-5">
          <a href="https://www.instagram.com/cptcamb/" target="_blank" rel="noreferrer" className="hover:text-gold transition-colors" data-testid="footer-instagram" aria-label="Instagram"><Instagram size={22} /></a>
          <a href="https://www.facebook.com/100068421196699" target="_blank" rel="noreferrer" className="hover:text-gold transition-colors" data-testid="footer-facebook" aria-label="Facebook"><Facebook size={22} /></a>
          <a href="mailto:cptcamb@gmail.com" className="hover:text-gold transition-colors" data-testid="footer-email" aria-label="Email"><Mail size={22} /></a>
        </div>
        <div className="flex flex-col gap-2">
          <Link to="/sponsors" className="eyebrow text-cream/80 hover:text-gold transition-colors">View Sponsors</Link>
          <a href="/#get-involved" className="eyebrow text-cream/80 hover:text-gold transition-colors">Get Involved</a>
          <Link to="/admin" className="eyebrow text-cream/50 hover:text-gold transition-colors text-[0.6rem]" data-testid="footer-admin-link">Organizer Login</Link>
        </div>
      </div>
    </div>
    <div className="border-t border-cream/20 py-5 text-center font-mono text-xs text-cream/60">
      © 2026 CPTCA · Pak Fest 2026 · Winnipeg, Manitoba
    </div>
  </footer>
);
